Vgr.resources = {
	apiV1: {
		default: "api/v1/",
		disposals: "api/v1/disposals/",
		quantitiesConversions: "api/v1/calculus/residues/[RESIDUE_CODE]/quantities-conversions/",
		scale: "api/v1/scales/"
	},
	apiV2: {
		disposal: "v2/organization-units/[ORGANIZATION_UNIT]/disposals/",
		temporaryStoragerReceiveDisposal:
			"v2/organization-units/[ORGANIZATION_UNIT]/disposals/[DISPOSAL]/temporary-storager-receivement/"
	},
	core: {
		accounts: "v1/accounts/",
		accountInfo: "v1/info/",
		areas: "v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATION_UNIT_CODE]/areas/",
		users: "v1/users/",
		organizationUsers: "v1/organizations/[ORGANIZATION]/users/",
		additionalProperties: "v1/organizations/[ORGANIZATION_ID]/additional-properties",
		organization: "v1/organizations/",
		organizationUnitRecipient:
			"v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATIONUNIT_CODE]/recipients",
		cities: "v1/cities",
		countries: "v1/countries",
		disposalTypes: "v1/disposal-types",
		measureUnits: "v1/measure-units"
	},
	sharedServices: {
		featureToggles: "v1/feature-toggles/",
		trackings: "v2/trackings/",
		files: "v1/organizations/[ORGANIZATION_ID]/files",
		notifications: "v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATION_UNIT]/vertown-notifications"
	},
	residuesManagement: {
		storagePreferences: "v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATION_UNIT]/storage-preferences",
		stockControlPreferences:
			"v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATION_UNIT]/stock-control-preferences",
		disposalsForFollowup:
			"v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATION_UNIT]/disposals/followup",
		disposalPreferences:
			"v1/organizations/[ORGANIZATION_ID]/organization-units/[ORGANIZATION_UNIT]/disposal-preferences",
		createDisposalManifest: "v1/organizations/[ORGANIZATION_ID]/disposal-manifests/[DISPOSAL_ID]"
	},
	suppliers: {
		suppliers: "v1/organizations/[ORGANIZATION]/suppliers/",
		organizationUnitSuppliers: "v1/organizations/[ORGANIZATION]/organization-units/[ORGANIZATION_UNIT]/suppliers",
		supplierVehicles: "v1/organizations/[ORGANIZATION]/suppliers/[SUPPLIER_CODE]/vehicles",
		supplierDrivers: "v1/organizations/[ORGANIZATION]/suppliers/[SUPPLIER_CODE]/drivers",
		supplierContacts: "v1/organizations/[ORGANIZATION]/suppliers/[SUPPLIER_CODE]/contacts",
		disposalDocuments: "v1/organizations/[ORGANIZATION]/disposals/documents",
		disposalCosts: "v1/organizations/[ORGANIZATION]/disposals/costs"
	},
	residues: {
		organizationUnitResidues: "v1/organizations/[ORGANIZATION]/organization-units/[ORGANIZATION_UNIT]/residues/"
	},
	integrations: {
		mtrSystems: "v1/organizations/[ORGANIZATION]/mtr-systems"
	},
	local: {
		apiV1: {
			scales: "api/v1/scales/"
		}
	}
};
